import exercise_data from './exercises.json';




export const DEFAULT_EXERCISE_LIST = Object.keys(exercise_data);

export const EXERCISES = exercise_data;   // have this step because I was thinking we could do some post translational modifications in this js file